/**
 * 静态营销资源集中管理
 *
 * 所有登录页 / Onboarding / 模板演示的图片视频统一从这里导出。
 * 改 URL 只需改这一个文件。
 *
 * Base URL 格式：
 *   COS 直连: https://octo-static-{appid}.cos.{region}.myqcloud.com
 *   CDN 加速: https://cdn.dobidobi.ai
 */

const STATIC_ASSET_BASE_URL = process.env.NEXT_PUBLIC_STATIC_ASSET_BASE_URL?.trim();

// ── 生产默认走 CDN，本地未配变量时回退 COS 直连 ──
const BASE = STATIC_ASSET_BASE_URL
  ? STATIC_ASSET_BASE_URL.replace(/\/+$/, '')
  : 'https://octo-static-1412329033.cos.ap-nanjing.myqcloud.com';

/** 拼接完整 URL，path 不带前导 / */
const url = (path: string) => `${BASE}/${path}`;

export const STATIC_ASSETS = {
  /** 元素分解 demo（登录页 + Onboarding） */
  decompose: {
    main:  url('landing/decompose/main.jpg'),
    face:  url('landing/decompose/face.jpg'),
    coat:  url('landing/decompose/coat.jpg'),
    pants: url('landing/decompose/pants.jpg'),
    bag:   url('landing/decompose/bag.jpg'),
    shoes: url('landing/decompose/shoes.jpg'),
  },
  /** AI 预览生成 demo（登录页 + Onboarding） */
  preview: {
    main:       url('landing/preview/main.jpg'),
    variation1: url('landing/preview/variation1.png'),
    variation2: url('landing/preview/variation2.png'),
    variation3: url('landing/preview/variation3.png'),
    video:      url('landing/preview/preview.mp4'),
  },
  /** 模板 face swap demo（TemplateUsePage） */
  templateDemo: {
    face:   url('landing/template-demo/face.png'),
    scene:  url('landing/template-demo/scene.png'),
    result: url('landing/template-demo/result.png'),
  },
  /** 首页 Showcase 轮播（GentleScrollShowcase） */
  showcase: {
    /** 第一屏 — ELEMENT DECOMPOSITION */
    s1: {
      bg: url('landing/showcase/01-image.png'),
      cards: [
        url('landing/showcase/02-image.png'),
        url('landing/showcase/03-image.png'),
        url('landing/showcase/04-image.png'),
        url('landing/showcase/05-image.png'),
      ],
    },
    /** 第二屏 — AI GENERATION */
    s2: {
      bg: url('landing/showcase-02/01-image.png'),
      cards: [
        url('landing/showcase-02/02-image.png'),
        url('landing/showcase-02/03-image.png'),
        url('landing/showcase-02/04-image.png'),
        url('landing/showcase-02/05-image.png'),
      ],
    },
    /** 第三屏 — ONE PHOTO / FULL LOOKBOOK */
    s3: {
      bg: url('landing/showcase-03/01-image.png'),
      cards: [
        url('landing/showcase-03/02-image.png'),
        url('landing/showcase-03/03-image.png'),
        url('landing/showcase-03/04-image.png'),
        url('landing/showcase-03/05-image.png'),
      ],
    },
  },
  /**
   * 登录页蓝色布料展示视频和首帧。
   *
   * 使用独立的语义化文件名，避免浏览器 / App WebView 继续复用旧路径下
   * 曾经发布过的走路男模视频及海报缓存。
   */
  loginShowcaseVideo: '/login-blue-fabric-showcase.mp4',
  loginShowcasePoster: '/login-blue-fabric-poster.jpg',
  /** 登录页 Gallery 轮播图片 */
  gallery: {
    g1:  url('landing/gallery/06d7356fda17a1a9a5735be10db0b4bc.jpg'),
    g2:  url('landing/gallery/09ceaee002bbc1e8d454646359c35d93.jpg'),
    g3:  url('landing/gallery/1f0a68bfea8c4b9da6f103ecffc0f9e5.jpg'),
    g4:  url('landing/gallery/1fde23f0e68c24a41a422d591fdd790d.jpg'),
    g5:  url('landing/gallery/2b9eba07fbf2429651ba325154573814.jpg'),
    g6:  url('landing/gallery/5292d90cf88265f6bf70f7fa2b78636d.jpg'),
    g7:  url('landing/gallery/7f943c430de63946788273833ab5f4b6.jpg'),
    g8:  url('landing/gallery/8b2c402d5528d8701b5f058d991d0341.jpg'),
    g9:  url('landing/gallery/931e80c1e9001021328d963dd89d1c8f.jpg'),
    g10: url('landing/gallery/93a441d97acf64c1bb3f0eb713b9b2ce.jpg'),
    g11: url('landing/gallery/93d47340bbadc507ff6d2e22530f8c00.jpg'),
    g12: url('landing/gallery/9f7e2517368e28bf79a7861343396376.jpg'),
    g13: url('landing/gallery/fad7fa91375d9e97006abcd1b8f357a7.jpg'),
    g14: url('landing/gallery/gucci.JPEG'),
    g15: url('landing/gallery/w2000_q60.jpg'),
  },
  /** 登录页 3-Boards 背景大图 */
  boards: {
    board1: url('landing/boards/001.jpg'),
    board2: url('landing/boards/002.jpg'),
    board3: url('landing/boards/003.jpg'),
  },
  /** 品牌 / 通用 */
  logoHover: '/logo-wordmark.png',
} as const;

/** 静态资源 Base URL，供 image-utils 等工具使用 */
export const STATIC_BASE_URL = BASE;
